import Box from '@mui/material/Box';
import muiStyled from '@mui/material/styles/styled';
import Typography from '@mui/material/Typography';

import ProjectInfo from './ProjectInfo';
import ProjectTitle from './ProjectTitle';
import {PROJECTS_GROUPING_TYPES, PROJECTS_VIEW_TYPES} from '../../../../const';
import useProjects from '../../../../hooks/providers/useProjects';
import {projectShape} from '../../../../proptypes-shapes';
import {isProjectDemo} from '../../../../utils';

const SpaceBetweenTitleAndUsersList = muiStyled(Box)(({theme}) => ({
  height: theme.spacing(2)
}));

const SirenContainer = muiStyled(Box)(({theme, isList}) => ({
  lineHeight: isList ? 1 : 'default',
  marginTop: theme.spacing(1),
  marginBottom: isList ? 0 : theme.spacing(1)
}));

// eslint-disable-next-line complexity
const ProjectNameOrLogo = ({project}) => {
  const {project_name: projectName, siren} = project;
  const {viewType, connectionGroupingType, getConnectorAssociatedToProject} = useProjects();

  const isList = viewType === PROJECTS_VIEW_TYPES.list;
  const isFolderGrouping = connectionGroupingType === PROJECTS_GROUPING_TYPES.folder;
  const isConnectionGrouping = connectionGroupingType === PROJECTS_GROUPING_TYPES.connection;
  const isDemo = isProjectDemo(siren);

  const connector = getConnectorAssociatedToProject(project);
  const cardTitle = isConnectionGrouping ? projectName : project.connector.toUpperCase();

  return (
    <Box flex={1} minWidth={0}>
      <ProjectTitle isFolderGrouping={isFolderGrouping} connector={connector} cardTitle={cardTitle} isListViewType={isList} />

      <SirenContainer isList={isList}>
        <ProjectInfo isDemo={isDemo} isList={isList} project={project} siren={siren} />
      </SirenContainer>

      {isDemo && !isList && <SpaceBetweenTitleAndUsersList />}
    </Box>
  );
};

ProjectNameOrLogo.propTypes = {
  project: projectShape.isRequired
};

export default ProjectNameOrLogo;
